import React from 'react'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import Link from 'next/link'

import { IData } from '@/components/blogImg'
import { PostImage } from '@/components/blogImg/Posts/Sections'
import Author from '../author'
import PostTags from './PostTags'
import Time from '@/lib/time'

interface IProps {
  post: IData
  isFirst: boolean
}

const PostBody = (props: IProps) => {
  const { post, isFirst } = props
  const link = `/${post.section}/${post.slug}`
  const { summary } = post.summary

  const containerClassName = isFirst
    ? 'rounded-2xl flex flex-col overflow-hidden transition-shadow hover:shadow-lg dark:hover:shadow-jacarta-100 md:flex-row mb-[1.875rem] md:mb-16'
    : 'rounded-2xl overflow-hidden transition-shadow hover:shadow-lg mb-[1.875rem] dark:hover:shadow-jacarta-100'

  const imageClassName = isFirst
    ? 'group overflow-hidden md:max-h-fit md:w-1/2'
    : 'group overflow-hidden'

  const contentClassName = isFirst
    ? 'dark:border-jacarta-600 dark:bg-jacarta-700 border-jacarta-100 rounded-b-[1.25rem] border bg-white p-[5%] md:w-1/2 md:rounded-none md:rounded-r-[1.25rem]'
    : 'dark:border-jacarta-600 dark:bg-jacarta-700 border-jacarta-100 rounded-b-[1.25rem] border border-t-0 p-[10%]'

  return (
    <div className={containerClassName}>
      <figure className={imageClassName}>
        <Link href={link}>
          <PostImage meta={post.metadata} slug={post.slug} />
        </Link>
      </figure>

      <div className={contentClassName}>
        <Author metadata={post.metadata}></Author>

        <h2 className='font-display text-jacarta-700 dark:hover:text-accent hover:text-accent mb-4 text-xl dark:text-white sm:text-3xl'>
          <Link href={link}>
            <span> {post.metadata.title} </span>
          </Link>
        </h2>
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>{summary}</ReactMarkdown>
        <div className='text-jacarta-400 flex flex-wrap items-center space-x-2 text-sm py-6 '>
          <span>•</span>
          <time>{Time.toLongLocal(post.metadata.date)}</time>
          <span>•</span>
          <PostTags tags={post.metadata.tag} />
        </div>
      </div>
    </div>
  )
}

export default PostBody
